import { render, staticRenderFns } from "./PptLayerTree.vue?vue&type=template&id=db8b1a34&"
import script from "./PptLayerTree.vue?vue&type=script&lang=js&"
export * from "./PptLayerTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/PptLayerTree.vue"
export default component.exports